import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Utils } from 'src/app/core/resources/utils';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { MenuServiceService } from '../../menu-service/menu-service.service';
import { MatSelectChange } from '@angular/material/select';
import { ModelCargo } from 'src/app/modules/cargo/manual-creation-cargo/resources/modelCargo';
import dataTypesMerchandiseJson from 'src/app/core/resources/JsonFile1572315390613.json';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Router } from '@angular/router';
import { Console } from 'console';
import { Global } from 'src/app/core/resources/global';
import { DateManager } from 'src/app/core/managers/date.manager';
import { Patterns } from 'src/app/core/resources/patterns';
import { Fmt } from 'src/app/core/messages/fmt';
import { RiskProfile } from 'src/app/core/interfaces/riskProfile';
import { MatDialogConfig, MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { CalculatorMeasurementsComponent } from 'src/app/modules/cargo/manual-creation-cargo/components/calculator-measurements/calculatorMeasurements.component';
import { Subscription } from 'rxjs';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { CargoManager, VEHICLE_TRIP_VALIDATION_EXCEPTION_CODE } from 'src/app/core/managers/cargo.manager';
import { AmountsCargoEnum } from 'src/app/core/enums/amountsCargo.enum';
import { Catalog } from 'src/app/core/interfaces/catalog';
import { ManualCreationCargoService } from 'src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service';
import { VehicleCargo } from 'src/app/core/interfaces/vehicle-cargo';
import { ServiceResources } from '../../resources/services';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { RiskProfileService } from 'src/app/core/services/risk-profile.service';

//TODO: Dialogo de agregar caracteristicas de carga
@Component({
  selector: 'app-load-characteristics-form',
  templateUrl: './load-characteristics-form.component.html',
  styleUrls: ['./load-characteristics-form.component.scss'],
  providers: [ModelCargo]
})
export class LoadCharacteristicsFormComponent implements OnInit, OnDestroy {
  permission = Permission;
  //Risk profile: se calcula automaticamente en backend (empresa + valor declarado); no es un
  //input manual en la creacion. El control se conserva para no romper referencias existentes.
  riskProfileControl = new FormControl(null);
  riskProfiles: RiskProfile[] = this.global.riskProfiles as RiskProfile[];
  //Container
  container = new FormControl(null, [Validators.pattern(this.patterns.CONTAINER_FORMAT_FULL.source)]);
  seal = new FormControl(null);
  containerExpirationDate = new FormControl(null);
  booking = new FormControl(null);
  //Load characteristics
  readonly minAmount = 0;
  minQuantity = 1;
  readonly minTotalWeigth = 0;
  maxTotalWeigth = AmountsCargoEnum.MAX_WEIGHT_ALLOWED_KG;
  amountControl = new FormControl(null, [Validators.min(this.minAmount)]);
  quantityControl = new FormControl(1, [Validators.min(this.minQuantity)]);
  totalWeigthControl = new FormControl(0, [Validators.required, Validators.min(this.minTotalWeigth), Validators.max(this.maxTotalWeigth)]);
  totalMeasurementControl = new FormControl(0, [Validators.required, Validators.min(this.minTotalWeigth)]);
  unitControl = new FormControl(null, [Validators.required]);
  typeControl = new FormControl(null, [Validators.required]);
  readonly minAmountDelivered = 1;
  amountDeliveredControl = new FormControl(null, [Validators.min(this.minAmountDelivered)]);
  vehicleCargo: VehicleCargo[] = [];
  formSubscription: Subscription;
  isDialog: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public paramsDialog: { cargo: Cargo },
    public dialogRef: MatDialogRef<LoadCharacteristicsFormComponent>,
    public menuService: MenuServiceService,
    public utils: Utils,
    public modelCargo: ModelCargo,
    private global: Global,
    private router: Router,
    private patterns: Patterns,
    private snackBarService: SnackBarService,
    private dialog: MatDialog,
    private permissionRole: PermissionRole,
    private manualCreationCargoService: ManualCreationCargoService,
    private serviceResources: ServiceResources,
    private cargoManager: CargoManager,
    public riskProfileService: RiskProfileService
  ) { }

  async ngOnInit() {
    await this.checkDialogParams();
    this.setLocalValues();
    this.setSubscription();
    this.checkPermissionsToEdit();
  }

  private async checkDialogParams() {
    if (this.paramsDialog && this.paramsDialog.cargo) {
      this.isDialog = true;
      this.menuService.cargo = this.paramsDialog.cargo;
      this.menuService.patchForm(this.paramsDialog.cargo, false);
      await this.menuService.setCargoConsignments();
      await this.menuService.setCargoVehicle();
    }
  }

  private async setLocalValues() {
    const riskProfile: RiskProfile = this.utils.getNestedValue(this.menuService.form.value, 'riskProfile');
    this.riskProfileControl.setValue(riskProfile && riskProfile.id && riskProfile.name ? { id: riskProfile.id, name: riskProfile.name } : null);
    this.riskProfileControl.setValidators(this.showRiskProfileSelector ? [Validators.required] : null);
    this.riskProfileControl.updateValueAndValidity();
    this.container.setValue(this.menuService.isContainerService() ? this.menuService.form.get('container').value : null);
    if (this.menuService.isRequiredContainerInfo()) this.container.setValidators([Validators.required, Validators.pattern(this.patterns.CONTAINER_FORMAT_FULL.source)]);
    this.seal.setValue(this.menuService.form.get('seal').value);
    if (this.menuService.isContainerService() && this.menuService.form.get('containerExpirationDate').value)
      this.containerExpirationDate.setValue(DateManager.stringToDate(this.menuService.form.get('containerExpirationDate').value, 'DD/MM/YYYY'));
    this.booking.setValue(this.menuService.isContainerService() ? this.menuService.form.get('booking').value : null);

    const hasManifestAuthorization = this.utils.getNestedValue(this.menuService.form.value, 'manifestAuthorization');
    this.minQuantity = this.menuService.isEmptyContainer() ? 0 : 1;
    this.quantityControl.setValidators([Validators.min(this.minQuantity)]);
    this.amountControl.setValue(!this.menuService.isTransportService() ? null : this.menuService.form.get('cargoFeature.cargoMeasure').value.amount);
    this.quantityControl.setValue(!this.menuService.isTransportService() ? null : this.menuService.form.get('cargoFeature.cargoMeasure.quantity').value);
    this.totalWeigthControl.setValue(!this.menuService.isTransportService() ? null : this.menuService.form.get('cargoFeature.cargoMeasure.totalWeigth').value);
    if (hasManifestAuthorization) this.totalWeigthControl.disable();
    this.totalMeasurementControl.setValue(!this.menuService.isTransportService() ? null : this.menuService.form.get('cargoFeature.cargoMeasure.totalMeasurement').value);
    this.unitControl.setValue(!this.menuService.isTransportService() ? null : this.menuService.form.get('cargoFeature.cargoMeasure.unit').value);
    if (hasManifestAuthorization) this.unitControl.disable();
    this.typeControl.setValue(!this.menuService.isTransportService() ? null : this.menuService.form.get('cargoFeature.cargoMeasure.type').value);
    if (this.canEditAmountDelivered) {
      const amountDelivered = this.utils.getNestedValue(this.menuService.form.value, 'cargoFeature.cargoMeasure.amountDelivered');
      this.amountDeliveredControl.setValue(amountDelivered);
      this.amountDeliveredControl.setValidators([Validators.max(this.totalWeigthControl.value)]);
      this.amountDeliveredControl.updateValueAndValidity();
    }
    if (!this.vehicleCargo.length)
      await this.getDataVehicle();
    this.setMaxTotalWeigth();
  }

  private async getDataVehicle() {
    let catalog: Catalog;
    try { catalog = await this.manualCreationCargoService.getVehicleType().toPromise() } catch (error) { }
    if (!catalog || !catalog.catalog || !catalog.catalog.length) return this.vehicleCargo = [];
    this.vehicleCargo = (catalog.catalog as VehicleCargo[]);

  }

  private async setMaxTotalWeigth() {
    const vehicleTypeName = this.utils.getNestedValue(this.menuService.cargo, 'cargoFeature.vehicleType.name');
    const vehicleData = this.vehicleCargo.find((item: VehicleCargo) => vehicleTypeName && vehicleTypeName === item.name);
    if (!vehicleData) {
      this.maxTotalWeigth = AmountsCargoEnum.MAX_WEIGHT_ALLOWED_KG;
      this.totalWeigthControl.setValidators([Validators.required, Validators.min(this.minTotalWeigth), Validators.max(this.maxTotalWeigth)]);
      return;
    }
    let infoVehicle: { id: string, name: string, weight: number };
    try { infoVehicle = await this.manualCreationCargoService.getVehicleWeightById(vehicleData.id).toPromise(); } catch (error) { }
    this.maxTotalWeigth = infoVehicle && infoVehicle.weight ? infoVehicle.weight : AmountsCargoEnum.MAX_WEIGHT_ALLOWED_KG;
    this.totalWeigthControl.setValidators([Validators.required, Validators.min(this.minTotalWeigth), Validators.max(this.maxTotalWeigth)]);
  }

  private setSubscription() {
    this.formSubscription = this.menuService.formObservable.subscribe(() => this.setLocalValues());
  }

  private checkPermissionsToEdit() {
    if (!this.canEditLoadCharacteristics) {
      this.riskProfileControl.disable();
      this.container.disable();
      this.seal.disable();
      this.containerExpirationDate.disable();
      this.booking.disable();
      this.amountControl.disable();
      this.quantityControl.disable();
      this.totalWeigthControl.disable();
      this.totalMeasurementControl.disable();
      this.unitControl.disable();
      this.typeControl.disable();
    }
    if (!this.canEditRiskProfile && this.menuService.isTransportService()) this.riskProfileControl.disable();
    const cargoState = this.utils.getNestedValue(this.menuService.cargo, 'state');
    if (cargoState === CargoStateEnum.END_SERVICE) {
      this.riskProfileControl.disable();
      this.amountControl.disable();
      this.quantityControl.disable();
      this.totalWeigthControl.disable();
      this.totalMeasurementControl.disable();
      this.unitControl.disable();
      this.typeControl.disable();
    }
    const hasConfirmedLicensePlate = this.utils.getNestedValue(this.menuService.cargo, 'confirmedDriver');
    if (hasConfirmedLicensePlate) this.riskProfileControl.disable();
    if (!this.canEditAmountDelivered) this.amountDeliveredControl.disable();
  }

  compareById(option1: RiskProfile, option2: RiskProfile): boolean {
    return option1 && option2 && option1.id === option2.id;
  }

  openDialogCalculatorMeasurements() {
    if (!this.canEditLoadCharacteristics) return;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(CalculatorMeasurementsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(totalSize => totalSize && this.totalMeasurementControl.setValue(totalSize));
  }

  get canEditLoadCharacteristics(): boolean {
    return this.canSeeLoadCharacteristics &&
      this.permissionRole.hasPermission(
        this.permission.cargo.module,
        this.permission.cargo.editServiceCharacteristicsModule
      );
  }

  get canEditAmountDelivered(): boolean {
    const state = this.utils.getNestedValue(this.menuService.cargo, 'state');
    const isCashed = !!this.utils.getNestedValue(this.menuService.cargo, 'shippingCost.cashed');
    const requiresMinistryLogisticTimes = !!this.utils.getNestedValue(this.menuService.cargo, 'requiresMinistryLogisticTimes');
    return this.canSeeLoadCharacteristics &&
      this.menuService.isTransportService() &&
      (!this.menuService.isMinistryService() || !requiresMinistryLogisticTimes) &&
      state === CargoStateEnum.END_SERVICE &&
      !isCashed;
  }

  get canEditRiskProfile(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.editRiskProfile
    );
  }

  /**
   * Con el interruptor de perfil de riesgo encendido, el backend lo calcula automaticamente
   * (empresa + valor declarado) y no se pide en la creacion. Apagado, se preserva la seleccion
   * manual previa a esa feature.
   */
  get showRiskProfileSelector(): boolean {
    return this.menuService.isTransportService() && !this.riskProfileService.enabled;
  }

  get canSeeLoadCharacteristics(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.showServiceCharacteristicsModule
    );
  }

  backToPreviousStep() {
    if (this.menuService.isEscortedService() || this.menuService.isSatelliteLockService())
      return this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.escortedVehicle, this.menuService.cargo.consecutive)]);
    const isRequiredLoadTypeService = this.menuService.isRequiredLoadTypeService();
    this.router.navigate([Fmt.string(isRequiredLoadTypeService
      ? this.serviceResources.serviceRequestUrls.cargoType
      : this.serviceResources.serviceRequestUrls.vehicle, this.menuService.cargo.consecutive)]);
  }

  private isValidForm(): boolean {
    if (!this.menuService.isTransportService()) return true;
    if (this.showRiskProfileSelector && this.utils.errorMessagesCustomized(this.riskProfileControl, 'perfil de riesgo')) return false;
    if (this.utils.errorMessagesCustomized(this.riskProfileControl, 'perfil de riesgo')) return false;
    if (this.menuService.isRequiredContainerInfo() && this.utils.errorMessagesCustomized(this.container, 'contenedor')) return false;
    if (this.utils.errorMessagesCustomized(this.amountControl, 'valor declarado de la mercancía', null, null, this.minAmount)) return false;
    if (this.utils.errorMessagesCustomized(this.totalMeasurementControl, 'medida total', null, null, this.minTotalWeigth)) return false;
    if (this.totalWeigthControl.value && this.utils.errorMessagesCustomized(this.quantityControl, 'número de unidades', null, null, this.minQuantity)) return false;
    if (this.utils.errorMessagesCustomized(this.totalWeigthControl, 'peso total', null, null, this.minTotalWeigth, this.maxTotalWeigth)) return false;
    if (this.totalWeigthControl.value && this.utils.errorMessagesCustomized(this.unitControl, 'unidad de medida')) return false;
    if (this.totalWeigthControl.value && this.utils.errorMessagesCustomized(this.typeControl, 'tipo de carga')) return false;
    if (this.canEditAmountDelivered && this.utils.errorMessagesCustomized(this.amountDeliveredControl, 'peso entregado', null, null, this.minAmountDelivered, this.totalWeigthControl.value)) return false;
    if (this.menuService.isRequiredContainerInfo() && this.container.value && this.container.invalid) {
      this.snackBarService.openSnackBar(this.utils.giveMessageError('INVALID_CONTAINER_GENERAL'), undefined, 'alert');
      return false;
    }
    return true;
  }

  saveAndContinue() {
    if (this.isDialog && !this.isValidForm()) return;
    if (this.showRiskProfileSelector) {
      this.menuService.form.get('riskProfile.name').setValue(
        this.riskProfileControl.value && this.riskProfileControl.value.name
          ? this.riskProfileControl.value.name : null
      );
      this.menuService.form.get('riskProfile.id').setValue(
        this.riskProfileControl.value && this.riskProfileControl.value.id
          ? this.riskProfileControl.value.id : null
      );
    }
    this.menuService.form.get('container').setValue(
      this.menuService.isRequiredContainerInfo() ? this.container.value : null
    );
    if (this.menuService.isRequiredContainerInfo() && this.container.value)
      (this.menuService.form.get('containers') as FormArray).value.push(this.container.value);
    this.menuService.form.get('seal').setValue(this.seal.value);
    this.menuService.form.get('containerExpirationDate').setValue(
      this.menuService.isContainerService() && this.containerExpirationDate.value
        ? DateManager.dateToString(this.containerExpirationDate.value, 'DD/MM/YYYY') : null
    );
    this.menuService.form.get('booking').setValue(
      this.menuService.isContainerService() ? this.booking.value : null
    );

    const amount = !this.menuService.isTransportService() ? null : this.utils.isDefined(this.amountControl.value) ? Number(this.amountControl.value) : null;
    if (!this.menuService.form.get('cargoFeature.cargoMeasure.amount')) {
      if (this.utils.isDefined(amount)) this.menuService.form.get('cargoFeature.cargoMeasure').addControl('amount', new FormControl(amount));
    } else this.menuService.form.get('cargoFeature.cargoMeasure.amount').setValue(amount);

    this.menuService.form.get('cargoFeature.cargoMeasure.quantity').setValue(
      !this.menuService.isTransportService() ? null : Number(this.quantityControl.value)
    );
    this.menuService.form.get('cargoFeature.cargoMeasure.totalWeigth').setValue(
      !this.menuService.isTransportService() ? null : Number(this.totalWeigthControl.value) <= this.maxTotalWeigth
        ? Number(this.totalWeigthControl.value) : this.maxTotalWeigth
    );
    this.menuService.form.get('cargoFeature.cargoMeasure.totalMeasurement').setValue(
      !this.menuService.isTransportService() ? null : Number(this.totalMeasurementControl.value)
    );
    this.menuService.form.get('cargoFeature.cargoMeasure.unit').setValue(
      !this.menuService.isTransportService() ? null : this.unitControl.value
    );
    this.menuService.form.get('cargoFeature.cargoMeasure.type').setValue(
      !this.menuService.isTransportService() ? null : this.typeControl.value
    );
    if (this.canEditAmountDelivered) {
      const amountDelivered = this.utils.isDefined(this.amountDeliveredControl.value) ? Number(this.amountDeliveredControl.value) : null;
      this.menuService.form.get('cargoFeature.cargoMeasure.amountDelivered').setValue(amountDelivered);
    }

    // Se captura el body ya armado, con el valor que se acaba de digitar, para que un reintento
    // con overrideRiskValidation lo reenvie tal cual: updateService()/refreshCargo() pisan el form
    // con lo persistido en cuanto el primer intento falla, así que releerlo en el reintento mandaría
    // el valor viejo en vez de este.
    const body = this.menuService.getBodyUpdateOnlyRequest();
    this.saveService(body);
  }

  private saveService(body: Cargo, overrideRiskValidation?: boolean) {
    this.menuService.updateServiceWithBody(body, overrideRiskValidation).then(() => {
      this.snackBarService.openSnackBar('Servicio actualizado exitosamente');
      if (!this.isDialog) this.continueToNextStep();
      else this.dialogRef.close({ state: true });
    }).catch(async (error) => {
      if (error && error.error && error.error.code === VEHICLE_TRIP_VALIDATION_EXCEPTION_CODE) {
        const { continueAnyway } = await this.cargoManager.showRiskValidationBlockedDialog(error.error.message);
        if (continueAnyway) return this.saveService(body, true);
      }
      this.snackBarService.openSnackBar('Ocurrió un error al actualizar el servicio', undefined, 'error');
    });
  }

  continueToNextStep() {
    if (this.menuService.isSatelliteLockService())
      return this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.satelliteLockService, this.menuService.cargo.consecutive)]);
    this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.additionalValuesService, this.menuService.cargo.consecutive)]);
  }

  ngOnDestroy() {
    if (this.formSubscription) this.formSubscription.unsubscribe();
  }
}
